document.addEventListener("DOMContentLoaded", () => {
  if (!customElements.get("swiper-carousel")) {
    customElements.define(
      "swiper-carousel",
      class SwiperCarousel extends HTMLElement {
        constructor() {
          super();
          this.swiperElement = this.querySelector(".swiper");
        }

        connectedCallback() {
          this.#setOptions();
          this.#setSlider();
        }

        #setOptions() {
          // Loop
          this.loop = this.dataset.loop || true;

          // Centered slides
          this.centered_slides =
            this.dataset.centered_slides == "true" || false;

          // Autoplay
          this.autoplay = this.dataset.autoplay || false;
          this.autoplay_delay = this.dataset.autoplay_delay || 4000;
          this.pauseOnMouseEnter = this.dataset.pause_on_mouse_enter || true;

          // Slides per view
          this.slides_per_view_sm = this.dataset.slides_per_view_sm || 1;
          this.space_between_sm = this.dataset.space_between_sm || 8;

          // Slides per view
          this.slides_per_view_md = this.dataset.slides_per_view_md || 2;
          this.space_between_md = this.dataset.space_between_md || 16;

          // Slides per view
          this.slides_per_view_lg = this.dataset.slides_per_view_lg || 4;
          this.space_between_lg = this.dataset.space_between_lg || 24;
        }

        #setSlider() {
          if (!this.swiperElement) return;
          this.swiper = new Swiper(this.swiperElement, {
            slidesPerView: this.slides_per_view_sm,
            spaceBetween: this.space_between_sm,
            loop: true,
            centeredSlides: this.centered_slides,
            breakpoints: {
              768: {
                slidesPerView: this.slides_per_view_md,
                spaceBetween: this.space_between_md,
              },
              1024: {
                slidesPerView: this.slides_per_view_lg,
                spaceBetween: this.space_between_lg,
              },
            },
            navigation: {
              nextEl: this.querySelector(".swiper-button-next"),
              prevEl: this.querySelector(".swiper-button-prev"),
            },
            pagination: {
              el: this.querySelector(".swiper-pagination"),
              clickable: true,
            },
            autoplay: {
              delay: this.autoplay_delay,
              pauseOnMouseEnter: this.pauseOnMouseEnter,
            },
          });
        }

        disconnectedCallback() {
          this.swiper.destroy();
        }
      }
    );
  }
});
